/* eslint-disable camelcase -- FIXME: automatically added for existing issue */
import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setBenefitPlanEnrollment = ({
  groupId: group_id,
  planId: plan_id,
}) =>
  call(websocketFetch, 'set_benefit_plan_enrollment', { group_id, plan_id });
